module.exports = __webpack_public_path__ + "img/demo-portfolio.8e574ce2.png";